module.exports = __webpack_public_path__ + "img/logout.d9f9cd50.png";